import * as THREE from 'three';
import Cloth from './cloth.js';

const WEBGL = {
	isWebGLAvailable: () => {
		try {
			const canvas = document.createElement('canvas');
			return !!(window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));
		} catch (error) {
            console.log(error);
			return false;
		}
	},
	isWebGL2Available: () => {
		try {
			const canvas = document.createElement('canvas');
			return !! (window.WebGL2RenderingContext && canvas.getContext('webgl2'));
		} catch (error) {
            console.log(error);
			return false;
		}
	}
};

let camera, scene, renderer, cloth;
const windForce = new THREE.Vector3(0, 0, 0);

function _canvasSize() {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 1024) {
        return 300;
    } else {
        return 500;
    }
}
const CANVAS_HEIGHT = _canvasSize();
const CANVAS_WIDTH = _canvasSize();

function prep() {
    renderer = new THREE.WebGLRenderer();
    renderer.setSize(CANVAS_WIDTH, CANVAS_HEIGHT);

    scene = new THREE.Scene();

    scene.add(new THREE.AmbientLight("#ffffff"));

    const light = new THREE.DirectionalLight(0xdfebff, 1);
    light.position.set(50, 200, 100);
    light.position.multiplyScalar(1.3);

    light.castShadow = true;

    light.shadow.mapSize.width = 1024;
    light.shadow.mapSize.height = 1024;

    const d = 300;

    light.shadow.camera.left = - d;
    light.shadow.camera.right = d;
    light.shadow.camera.top = d;
    light.shadow.camera.bottom = - d;

    light.shadow.camera.far = 1000;

    scene.add(light);

    camera = new THREE.PerspectiveCamera(50, CANVAS_WIDTH / CANVAS_HEIGHT, 1, 1000);
    camera.position.set(0, 0, 600);
    camera.lookAt(scene.position);

    cloth = new Cloth();

    scene.add(cloth.render());

    removeContainerContents();
};

function removeContainerContents() {
    let container = document.getElementById('canvas');

    while (container.firstChild) container.firstChild.remove();

    container.appendChild(renderer.domElement);
}

function animate() {
    const time = Date.now();

    const windStrength = Math.cos(time / 10000) * 5 + 10;

    windForce.set(Math.sin(time / 2000), Math.cos(time / 3000), Math.sin(time / 1000));
    windForce.normalize();
    windForce.multiplyScalar(windStrength);

    cloth.animate(time, windForce);

    renderer.render(scene, camera);

    requestAnimationFrame(animate);
};

function noWebGL() {
    const container = document.getElementById('canvas');
    const image = document.createElement('img');
    image.setAttribute("src", "./assets/img/hero/loading.gif");
    image.setAttribute("alt", "It's all television");

    while (container.firstChild) container.firstChild.remove();

    container.appendChild(image);
}

function threeDee() {
    if (WEBGL.isWebGLAvailable()) {
        prep();
        animate();
    } else {
        noWebGL();
    }
}
threeDee();
